import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Form, Row, Card, CardGroup, Col, Button, Table } from 'react-bootstrap';
import DommusRequiredSpan from "../../../components/DommusRequiredSpan";
import caAPI from "../../../services/caAPI";
import CommonService from "../../../services/CommonService";
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import Swal from "sweetalert2";
import MidiaSocialIcone from "../../../components/MidiaSocialIcone";
import "./style.scss";
import { trackPromise } from "react-promise-tracker";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";
import { AtendentesContext } from "../../../contexts/AtendentesContext";
import { VoipContext } from "../../../contexts/VoipContext";
import { MeioComunicacaoContext } from "../../../contexts/MeioComunicacaoContext";
import { celularMask } from "../../../components/InputTextMask";
import useTelefoneInternacionalInput from '../../../hooks/useTelefoneInternacionalInput';
import CreatableSelect from "react-select/creatable";
import { errorToast, successToast } from '../../../components/DommusToast';
import { BsFillTelephoneOutboundFill } from 'react-icons/bs';
import {isMobile} from 'react-device-detect';
import DommusLoadingInput from '../../../components/DommusLoading/DommusLoadingInput';
import DommusloadingSquare from '../../../components/DommusLoading/DommusLoadingSquare';
import ContatoService from '../../../services/ContatoService';
import ModalDommus from '../../../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons';

export default function ModalNovoAtendimento({ posicaoListaAtentimentos, setOpenModalNovoAtendimento, idAtendimento }) {

    const [atendimentoEditar, setAtendimentoEditar] = useState();
    const [meioComunicacaoInput, setMeioComunicacaoInput] = useState();
    const [situacaoInput, setSituacaoInput] = useState();
    const [atendenteInput, setAtendenteInput] = useState();
    const [tipoAtendimentoInput, setTipoAtendimentoInput] = useState();
    const [nomeDestinatarioInput, setNomeDestinatarioInput] = useState();
    const [contatoDestinatarioInput, setContatoDestinatarioInput] = useState("");
    const [contatoOrigemInput, setContatoOrigemInput] = useState();
    const [ramalInput, setRamalInput] = useState();
    const [listaSituacao, setListaSituacao] = useState();
    const [listaTipoAtendimento, setListaTipoAtendimento] = useState();
    const [maskDestinatarioType, setMaskDestinatarioType] = useState();
    const [textButton, setTextButton] = useState('Iniciar Atendimento');
    const [listaContatoOrigem, setListaContatoOrigem] = useState([]);
    const [openModalAgenda, setOpenModalAgenda] = useState(false);
    const [listaContatosAgenda, setListaContatosAgenda] = useState([]);
    const [buscaAgenda, setBuscaAgenda] = useState('');
    const [contatoAgendaSelecionado, setContatoAgendaSelecionado] = useState(null);
    const [telefoneSelecionadoPorContato, setTelefoneSelecionadoPorContato] = useState({});
    const [refInputTelefone, objetoInputTelefone, getNumeroInternacional] = useTelefoneInternacionalInput(atendimentoEditar?.contato_destino);
    const { handleAdiconaLista,  listaAtendimentos,  handleReloadAtendimento, setListaAtendimentos, setAtendimentoAtivo, usuarioBloqueadoCriarTagInput} = useContext(AtendimentoContext);
    const { listaAtendentes, resolverNomeAtendente, validarUsuarioAtualAtendePorAtendimento } = useContext(AtendentesContext);
    const [enviando, setEnviando] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [listaTags, setListaTags] = useState([]);
    const [observacaoFinalizacao, setObservacaoFinalizacao] = useState("");
    const {meiosComunicacao} = useContext(MeioComunicacaoContext)
    const {inCallStatus} = useContext(VoipContext);
    const animatedComponents = makeAnimated();
    //aplica mascara do contato destino quando for número
    useEffect(() => {
      if (atendimentoEditar) {
          setTextButton('Salvar Alterações');
          if(maskDestinatarioType === 'phone'){
            setContatoDestinatarioInput(celularMask(atendimentoEditar.contato_destino, true));
          }else{
            setContatoDestinatarioInput(atendimentoEditar.contato_destino);
          }
          setMeioComunicacaoInput(atendimentoEditar.meio_comunicacao.slug);
          setObservacaoFinalizacao(atendimentoEditar?.finalizacao_atendimento?.observacao?.observacao ?? "");
          return;
      }
      if (maskDestinatarioType === 'phone') {
          setContatoDestinatarioInput(val => celularMask(val, true));
      }
    }, [contatoDestinatarioInput, maskDestinatarioType, atendimentoEditar])

    useEffect(() => {
        trackPromise(
            caAPI.situacao.list().then(res => {
                setListaSituacao(res.data);
            }).catch(err => Swal.fire({
                titleText: "Erro",
                text: "Houve um problema ao buscar a lista de situações  " + err,
                icon: 'error'
            })),

            caAPI.tipo_atendimento.list().then(res => {
                setListaTipoAtendimento(res.data);
            }).catch(err => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Houve um problema ao buscar os tipos de atendimento  " + err,
                    icon: 'error'
                });
            }),

            caAPI.tags.list().then(res => {
            let formatado = res.data.data.map((value)=>{
                return{
                    value: value.id_tag,
                    label: value.nome,
                }
            });


            setListaTags(formatado);
            }).catch(err => {
            Swal.fire({
                titleText: "Erro",
                text: "Houve um problema ao buscar as tags  " + err,
                icon: 'error'
            });
            }),
        )
    }, [])

    //Busca atendimento via IdAtendimento
    useEffect(() => {
        if (idAtendimento) {
            trackPromise(
                caAPI.atendimento.find(idAtendimento).then(res => {
                    setAtendimentoEditar(res.data);
                    setNomeDestinatarioInput(res.data.nome);
                    setContatoDestinatarioInput(celularMask(res.data.contato_destino, true));
                    setContatoOrigemInput(res.data.contato_origem);
                    setRamalInput(res.data.ramal);
                    setTipoAtendimentoInput({
                      label: res.data?.tipo_atendimento?.descricao,
                      value: res.data?.tipo_atendimento?.id
                    });
                    setSituacaoInput({
                      label: res.data?.situacao_atendimento?.nome,
                      value: res.data?.situacao_atendimento?.id
                    });
                    let atendente = listaAtendentes?.find((item) => Number(item.id) === Number(res?.data?.atendente));
                    setAtendenteInput({
                      label: atendente?.nome,
                      value: atendente?.id
                    })
                    setSelectedTags(res.data.tags.map((tag)=>{
                        return {
                            value: tag.id_tag,
                            label: tag.nome,
                        }
                    }));
                }).catch(err => {
                    Swal.fire({
                        titleText: "Erro",
                        text: "Houve um problema ao buscar o Atendimento",
                        icon: 'error'
                    });
                })
            , 'loading-inputs-edicao')
        }
    }, [idAtendimento]);

    const removerTag = (tags)=>{
        if(idAtendimento){
            let formatValues = {
                tags: tags.map((tag)=>{return {id_atendimento: idAtendimento, id_tag: tag.value, nome: tag.label}})
            };
            caAPI.tags.removerTagsAtendimento(formatValues).then(
                (response)=>{
                    successToast.fire({text: "Tag removida com sucesso!"});
                }
            )
            .catch((error) => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Erro ao remover tag: " + error,
                    icon: 'error'
                })
            });
        }
    }

    const definirContatoOrigem = (opcoesSelecionadas) => {
        let novoValor = null;
        let novoRamal = null;
        if(opcoesSelecionadas && opcoesSelecionadas.length){
            novoValor = opcoesSelecionadas[0].value;
            novoRamal = opcoesSelecionadas[0].dataset.ramal;
        }
        setContatoOrigemInput(novoValor);
        setRamalInput(novoRamal);
    }

    function atendimentoExiste(atendimento) {
        Swal.fire({
            titleText: "Já existe um atendimento aberto com esse contato para  " + atendimento.nome,
            text: "Deseja abrir a janela deste atendimento?",
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                    handleAdiconaLista(atendimento);
                    setAtendimentoAtivo(atendimento);
            }
        })
    };


    const handleTagsSelecao = (values)=>{
        if(values.length > selectedTags.length){
            setSelectedTags(values);
        }else{
            let removido = selectedTags.filter((tag)=>{return !values.includes(tag);});
            setSelectedTags(values);
            removerTag(removido);
        }
    }

    function buscarListaContatosOrigem(slug) {
        trackPromise(caAPI.meio_comunicacao.buscarContatoOrigem(slug)).then(
            (res) => {
                setListaContatoOrigem(res.data);
            }
        );
    }
    
    useEffect(() => {
        const novoMask = meioComunicacaoInput === 'email' ? 'email' : (meioComunicacaoInput === 'voip' || meioComunicacaoInput === 'whatsapp' || meioComunicacaoInput === 'sms') ? 'phone' : undefined;
        if (novoMask !== maskDestinatarioType && !atendimentoEditar) {
            setContatoDestinatarioInput('');
            setNomeDestinatarioInput('');
            setContatoOrigemInput(null);
            setContatoAgendaSelecionado(null);
            setTelefoneSelecionadoPorContato({});
        }

        setMaskDestinatarioType(novoMask);
    }, [meioComunicacaoInput]);
    
    const handleAbrirModalAgenda = () => {
        setBuscaAgenda('');
            ContatoService.index({ ativo: '1' }).then((res) => {
            const contatos = res.data?.data || res.data || [];
            setListaContatosAgenda(contatos);
        }).catch(() => {
            setListaContatosAgenda([]);
        });
        setOpenModalAgenda(true);
    };

    // Filtra contatos da agenda conforme o meio de comunicação e busca
    const contatosAgendaFiltrados = useMemo(() => {
        let filtrados = listaContatosAgenda;
        
        if (maskDestinatarioType === 'email') {
            filtrados = filtrados.filter(c => c.email);
        } else if (maskDestinatarioType === 'phone') {
            filtrados = filtrados.filter(c => c.telefones?.length > 0);
        }
        
        if (buscaAgenda.trim()) {
            const termo = buscaAgenda.toLowerCase().trim();
            filtrados = filtrados.filter(c =>
                c.nome?.toLowerCase().includes(termo) ||
                c.email?.toLowerCase().includes(termo) ||
                c.telefones?.some(t => t.telefone?.includes(termo))
            );
        }

        return filtrados;
    }, [listaContatosAgenda, maskDestinatarioType, buscaAgenda]);

    // Seleciona contato da agenda e preenche campos
    const handleSelecionarContatoAgenda = (contato) => {
        setContatoAgendaSelecionado(contato);
        setNomeDestinatarioInput(contato.nome);
        if (maskDestinatarioType === 'email' && contato.email) {
            setContatoDestinatarioInput(contato.email);
        } else if (maskDestinatarioType === 'phone' && contato.telefones?.length) {
            const indiceSelecionado = telefoneSelecionadoPorContato[contato.id_contato] || 0;
            const telefone = contato.telefones[indiceSelecionado]?.telefone || contato.telefones[0].telefone;
            setContatoDestinatarioInput(celularMask(telefone, true));
        } else if (contato.telefones?.length) {
            const indiceSelecionado = telefoneSelecionadoPorContato[contato.id_contato] || 0;
            setContatoDestinatarioInput(contato.telefones[indiceSelecionado]?.telefone || contato.telefones[0].telefone);
        } else if (contato.email) {
            setContatoDestinatarioInput(contato.email);
        }
        setOpenModalAgenda(false);
    };

    // Limpa seleção da agenda
    const handleLimparContatoAgenda = () => {
        setContatoAgendaSelecionado(null);
        setNomeDestinatarioInput('');
        setContatoDestinatarioInput('');
    };
    
    const handleSubmitForm = function () {
        let contatoDestino = contatoDestinatarioInput;
        if (objetoInputTelefone) {
          contatoDestino = getNumeroInternacional();
        } else if (maskDestinatarioType === 'email') {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(String(contatoDestinatarioInput).toLowerCase())) {
                Swal.fire({
                    titleText: "Atenção",
                    text: "Digite um email válido",
                    icon: 'info'
                });
                return;
            }
        } else if (maskDestinatarioType === 'phone'){
          if (contatoDestinatarioInput) {
                contatoDestino = CommonService.formatarDeMascaraPhone(contatoDestinatarioInput);
            }
        }
        
        if (maskDestinatarioType === 'phone') {
            const digitos = String(contatoDestino || '').replace(/\D/g, '');
            if (!digitos || digitos.length < 8) {
                Swal.fire({
                    titleText: "Atenção",
                    text: "Digite um telefone válido",
                    icon: 'info'
                });
                return;
            }
        }
        const meiosDeComunicacaoContatoOrigemObrigatorio = [
            'voip', 
            'whatsapp', 
            'email'
        ];
        if (!situacaoInput ||
            !tipoAtendimentoInput ||
            !meioComunicacaoInput ||
            !nomeDestinatarioInput ||
            !contatoDestinatarioInput ||
            (meiosDeComunicacaoContatoOrigemObrigatorio.includes(meioComunicacaoInput) && !contatoOrigemInput)
        ) {
            Swal.fire({
                titleText: "Atenção",
                text: "Preecha todos os campos obrigatórios",
                icon: 'info'
            });
            return;
        }
        const novoEnviando = true;
        setEnviando(novoEnviando);
        var data = {
            situacao: situacaoInput?.value ?? situacaoInput,
            atendente: atendenteInput?.value ?? atendenteInput,
            tipo_atendimento: tipoAtendimentoInput?.value ?? tipoAtendimentoInput,
            meio_comunicacao: meioComunicacaoInput,
            contato_origem: contatoOrigemInput,
            contato_destino: contatoDestino,
            observacao_finalizacao: Number(situacaoInput) === 4 ? observacaoFinalizacao ?? "" : null,
            ramal: ramalInput,
            nome: nomeDestinatarioInput,
            tags: selectedTags.map((tag)=>{
                return{
                    id_tag: tag.__isNew__ ? null : tag.value,
                    nome: tag.label,
                }
            }),
        }
       
        if (atendimentoEditar) {
            trackPromise(caAPI.atendimento.update(data, idAtendimento).then(res => {
              const novaListaAtendimentos = listaAtendimentos.slice();
              let novoAtendimento = res.data;
              if(validarUsuarioAtualAtendePorAtendimento(novoAtendimento)) {
                novoAtendimento.nome_atendente = resolverNomeAtendente(novoAtendimento.atendente);
                novaListaAtendimentos.splice(posicaoListaAtentimentos, 1, novoAtendimento);
                handleReloadAtendimento()
              }else{
                novaListaAtendimentos.splice(posicaoListaAtentimentos, 1);
                setAtendimentoAtivo(null);
              }
              setListaAtendimentos(novaListaAtendimentos);
              setOpenModalNovoAtendimento(false);
              const novoEnviando = false;
              setEnviando(novoEnviando);
            }).catch(err => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Erro ao editar atendimento",
                    icon: 'error'
                });
                const novoEnviando = false;
                setEnviando(novoEnviando);
            }))
        }
        else {
            data.direcao = 'A';
            trackPromise(caAPI.atendimento.create(data).then(res => {
                handleAdiconaLista(res.data)
                if(res.data?.mensagem == "existe") {
                 setOpenModalNovoAtendimento(false);
                 atendimentoExiste(res.data.conteudo)
                }else{
                    setOpenModalNovoAtendimento(false);
                    const novoEnviando = false;
                    setEnviando(novoEnviando);
                }
                if(res.data?.origem?.id_template_resposta_auto_criar_atendimento){
                  enviarRespostaAutomaticaTemplate(res?.data?.id);
                }
            }).catch(err => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Erro ao criar/editar atendimento",
                    icon: 'error'
                });
                const novoEnviando = false;
                setEnviando(novoEnviando);
            }))
        }
    };

    const enviarRespostaAutomaticaTemplate = (idAtendimento) => {
      Swal.fire({
        position: 'center',
        icon: "question",
        title: 'Existe um disparo automático programado para criação deste atendimento. Deseja prosseguir com o disparo?',
        showCloseButton: false,
        showCancelButton: true,
        confirmButtonText: 'Sim, prosseguir',
        cancelButtonText: 'Não, cancelar',
        customClass: {
          confirmButton: 'btn btn-primary mr-2',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false,
      }).then((result) => {
          if ( result.isConfirmed) {
            const payload = {
              id_atendimento: idAtendimento,
              utilizar_fila: true
            }
            caAPI.atendimento.enviarRespostaAutomaticaTemplate(payload).then((res) => {
              successToast.fire("Resposta automática enviada com sucesso");
            }).catch((err) => {
              errorToast.fire("Erro ao enviar resposta automática");
            })
          }
      })
    }

    const handleOnCreateOptionTag = async (inputValue) => {
      if(usuarioBloqueadoCriarTagInput){
        errorToast.fire("Você não tem permissão para criar tags");
        return;
      }
      const trimmed = inputValue.trim();
      if (!trimmed) return;

      const newOption = { value: trimmed, label: trimmed, __isNew__:true };
      setListaTags(prev => [...prev, newOption]);
      setSelectedTags(prev => Array.isArray(prev) ? [...prev, newOption] : newOption);
    }

    return <div className="novoAtendimento">
    <Form>

        <Row>
            <Col xl={3}>
                    <Form.Group >
                        <Form.Label >
                            Meio de Comunicação: <DommusRequiredSpan />
                        </Form.Label>
                        <DommusloadingSquare area={'loading-inputs-edicao'}>
                        <Form.Control
                            as="radio"
                            custom
                            onChange={(event) => {
                                setMeioComunicacaoInput(event.target.id);
                                buscarListaContatosOrigem(event.target.id);
                            }}
                        >
                            {!isMobile && <CardGroup>
                                {meiosComunicacao && !atendimentoEditar && meiosComunicacao.map((midia) => {
                                    return (
                                        midia.criavel === 1 && (
                                            <div key={midia.id}>
                                                <Card className="midiaCard">
                                                    <Card.Body className="midiaCorpo">
                                                        <Form.Check
                                                            className="midia"
                                                            type="radio"
                                                            id={midia.slug}
                                                            value={midia.slug}
                                                        >
                                                            <Form.Check.Input type='radio' name="selecionaMidia" isValid />
                                                            <Form.Check.Label >
                                                                <MidiaSocialIcone midia={midia.slug} />
                                                            </Form.Check.Label>
                                                        </Form.Check>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        )
                                    )
                                }
                                )}

                                {!!atendimentoEditar &&
                                    <Card className="midiaCard">
                                        <Card.Body className="midiaCorpo">
                                            <Form.Check
                                                className="midia"
                                                type="radio"
                                                id={atendimentoEditar.meio_comunicacao.slug}
                                                value={atendimentoEditar.meio_comunicacao.slug}
                                            >
                                                <Form.Check.Input checked={true} type='radio' name="selecionaMidia" isValid />
                                                <Form.Check.Label >
                                                    <MidiaSocialIcone midia={atendimentoEditar.meio_comunicacao.slug} />
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </Card.Body>
                                    </Card>
                                }
                            </CardGroup>}
                            {
                              isMobile && meiosComunicacao && meiosComunicacao.length && (
                                <Row xs={3} md={2}
                                  className={`gs-${((meiosComunicacao.length % 2 == 0) ? meiosComunicacao.length : (meiosComunicacao.length + 1))}`}>
                                { !atendimentoEditar && meiosComunicacao  && meiosComunicacao.map((midia) => {
                                    return <Col key={midia.id}>
                                              <Card className="midiaCard">
                                                  <Card.Body className="midiaCorpo">
                                                      <Form.Check
                                                          className="midia"
                                                          type="radio"
                                                          id={midia.slug}
                                                          value={midia.slug}
                                                      >
                                                          <Form.Check.Input type='radio' name="selecionaMidia" isValid />
                                                          <Form.Check.Label >
                                                              <MidiaSocialIcone midia={midia.slug} />
                                                          </Form.Check.Label>
                                                      </Form.Check>
                                                  </Card.Body>
                                              </Card>
                                            </Col>;
                                  })
                                }
                                { atendimentoEditar &&
                                  <Col>
                                    <Card className="midiaCard">
                                        <Card.Body className="midiaCorpo">
                                            <Form.Check
                                                className="midia"
                                                type="radio"
                                                id={atendimentoEditar.meio_comunicacao.slug}
                                                value={atendimentoEditar.meio_comunicacao.slug}
                                            >
                                                <Form.Check.Input checked={true} type='radio' name="selecionaMidia" isValid />
                                                <Form.Check.Label >
                                                    <MidiaSocialIcone midia={atendimentoEditar.meio_comunicacao.slug} />
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </Card.Body>
                                    </Card>
                                  </Col>
                                }
                                </Row>
                              )
                            }
                        </Form.Control>
                      </DommusloadingSquare>
                    </Form.Group>
                    { atendimentoEditar &&
                    <div className='contato-origem-section'>
                        <span className='label'>Originado por:</span>
                        <div className='text'>
                            <BsFillTelephoneOutboundFill/>
                            {atendimentoEditar.meio_comunicacao?.contatos_origem?.find((contato)=>contato.valor === atendimentoEditar.contato_origem)?.descricao || "---"}
                        </div>
                    </div>
                    }
            </Col>
            <Col>
                <Row xs={1} md={2}>
                    <Col>
                        <Form.Group as={Col}  controlId="formDestinatario">
                            <Form.Label>Nome{(!isMobile && " Destinatário") || ""}: <DommusRequiredSpan /></Form.Label>
                            <DommusLoadingInput area={'loading-inputs-edicao'}>
                              <Form.Control type="text" value={nomeDestinatarioInput}
                                  disabled={!!contatoAgendaSelecionado && !atendimentoEditar}
                                  onChange={(event) => setNomeDestinatarioInput(event.target.value)} />
                            </DommusLoadingInput>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group as={Col} controlId="formContatoDestinatario">
                            <Form.Label>Contato{(!isMobile && " Destinatário") || ""}: <DommusRequiredSpan /></Form.Label>
                            <DommusLoadingInput area={'loading-inputs-edicao'}>
                              <div className="contato-destinatario-wrapper">
                                <Form.Control type="text" value={contatoDestinatarioInput} disabled={!!atendimentoEditar || (!!contatoAgendaSelecionado && !atendimentoEditar)} ref={(meioComunicacaoInput == 'whatsapp' && refInputTelefone) || null}
                                    onChange={(event) => setContatoDestinatarioInput(meioComunicacaoInput == 'whatsapp' ? getNumeroInternacional() : event.target.value)} />
                                {meioComunicacaoInput && !atendimentoEditar && (
                                  <span className="btn-agenda-contato">
                                    {contatoAgendaSelecionado ? (
                                      <Button variant="outline-danger" size="sm" title="Limpar contato da agenda" onClick={handleLimparContatoAgenda}>
                                        ✕
                                      </Button>
                                    ) : (
                                      <Button variant="outline-primary" size="sm" title="Buscar na Agenda" onClick={handleAbrirModalAgenda}>
                                        <FontAwesomeIcon icon={faAddressBook} />
                                      </Button>
                                    )}
                                  </span>
                                )}
                              </div>
                            </DommusLoadingInput>
                        </Form.Group>
                    </Col>
                </Row>
                <Row xs={1} md={2}>
                    <Col >
                        <Form.Group as={Col} controlId="formSituacao">
                            <Form.Label>Status{(!isMobile && " do Atendimento") || ""}: <DommusRequiredSpan /></Form.Label>
                              <DommusLoadingInput area={'loading-inputs-edicao'}>
                              <Select
                                value={situacaoInput}
                                options={listaSituacao?.map((situacao) => {return {label: situacao.nome, value: situacao.id}}) ?? []}
                                components={animatedComponents}
                                name="colors"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                menuPosition={"absolute"}
                                onChange={setSituacaoInput}
                              />
                            </DommusLoadingInput>
                        </Form.Group>
                    </Col>
                    <Col >
                        <Form.Group as={Col} controlId="formAtendimento">
                            <Form.Label>Tipo{(!isMobile && " do Atendimento") || ""}: <DommusRequiredSpan /></Form.Label>
                            <DommusLoadingInput area={'loading-inputs-edicao'}>
                              <Select
                                value={tipoAtendimentoInput}
                                options={listaTipoAtendimento?.map((tipo) => {return {label: tipo.descricao, value: tipo.id}}) ?? []}
                                components={animatedComponents}
                                name="colors"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                menuPosition={"absolute"}
                                onChange={setTipoAtendimentoInput}
                              />
                            </DommusLoadingInput>
                        </Form.Group>
                    </Col>
                </Row>
                <Row xs={1} md={atendimentoEditar ? 3 : 2}>
                    <Col
                        style={listaContatoOrigem && listaContatoOrigem.length > 0 ? {} : { display: "none" }}
                    >
                        <Form.Group as={Col} controlId="formNome">
                            <Form.Label>Originado por: <DommusRequiredSpan /></Form.Label>
                            <DommusLoadingInput area={'loading-inputs-edicao'}>
                              <Form.Control
                                  disabled={((listaContatoOrigem && !listaContatoOrigem.length > 0) || !!atendimentoEditar) ?? "disabled"}
                                  as="select" custom onChange={(event) => definirContatoOrigem(event.target.selectedOptions)}>
                                  <option hidden>Selecione o contato para origem</option>
                                  {listaContatoOrigem && listaContatoOrigem.map((numero, index) => {
                                      const selected = contatoOrigemInput && contatoOrigemInput == numero.valor && (ramalInput || ramalInput === 0) && ramalInput == numero.ramal;
                                      return <option key={index} selected={selected} data-ramal={numero.ramal} value={numero.valor}>{numero.descricao ?? numero.valor}</option>;
                                  })
                                  }
                              </Form.Control>
                            </DommusLoadingInput>
                        </Form.Group>
                    </Col>
                    {atendimentoEditar ?
                        <Col>
                            <Form.Group as={Col} controlId="formAtendente">
                                <Form.Label>Atendente: <DommusRequiredSpan /></Form.Label>
                                  <DommusLoadingInput area={'loading-inputs-edicao'}>
                                  <Select
                                    value={atendenteInput}
                                    isDisabled={inCallStatus && idAtendimento}
                                    options={listaAtendentes?.map((atendente) => {return {label: atendente.nome, value: atendente.id}}) ?? []}
                                    components={animatedComponents}
                                    name="colors"
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    menuPosition={"absolute"}
                                    onChange={setAtendenteInput}
                                  />
                                </DommusLoadingInput>
                            </Form.Group>
                        </Col>
                        :
                        <></>
                    }
                </Row>
                <Row>
                  <Col>
                    <Form.Group as={Col} controlId="formAtendente">
                        <Form.Label>Tags{(!isMobile && " do Atendimento") || ""}:</Form.Label>
                        <DommusLoadingInput area={'loading-inputs-edicao'}>
                          <CreatableSelect
                              isMulti
                              options={listaTags}
                              formatCreateLabel={() => `Cadastrar`}
                              className="basic-multi-select"
                              menuPlacement='top'
                              name="tagsAtendimento"
                              placeholder={`Selecionar ${!usuarioBloqueadoCriarTagInput ? ' ou  criar' : ""}`}
                              onChange={(event) =>  handleTagsSelecao(event)}
                              onCreateOption={handleOnCreateOptionTag}
                              value={selectedTags}
                              maxMenuHeight= {190}
                          />
                        </DommusLoadingInput>
                    </Form.Group>
                  </Col>
                </Row>
                {atendimentoEditar?.id && Number(situacaoInput) === 4 && 
                  <Row>
                    <Col lg={12}>
                      <Form.Group as={Col}>
                        <Form.Label>Observação para Finalização:</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          onChange={(e)=>{setObservacaoFinalizacao(e.target.value)}}
                          placeholder="Informe um descrição sobre a conclusão do atendimento:"
                          value={observacaoFinalizacao}
                        >
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                }
            </Col>
        </Row>
        {
          (!enviando) && <button type="button" className="btn btn-block btn-primary btnNovoEditar" onClick={handleSubmitForm}>{textButton}</button>
        }
        </Form>
        
        {openModalAgenda && (
            <div style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1065,
            }} />
        )}

        <ModalDommus
            open={openModalAgenda}
            close={() => setOpenModalAgenda(false)}
            titulo="Agenda de Contatos"
            size="md"
            zindex="1070"
            backdrop={false}
        >
            <div className="modal-agenda-contatos">
                <Form.Group className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Pesquisar por nome, telefone ou e-mail..."
                        value={buscaAgenda}
                        onChange={(e) => setBuscaAgenda(e.target.value)}
                    />
                </Form.Group>
                {contatosAgendaFiltrados.length ? (
                    <div className="agenda-tabela-wrapper">
                        <table className="agenda-tabela">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>{maskDestinatarioType === 'email' ? 'E-mail' : 'Telefone'}</th>
                                    <th style={{width: '80px'}}>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contatosAgendaFiltrados.map((contato) => {
                                    const isEmail = maskDestinatarioType === 'email';
                                    let colContato;

                                    if (isEmail) {
                                        colContato = contato.email || '---';
                                    } else if (contato.telefones?.length > 1) {
                                        const indiceSelecionado = telefoneSelecionadoPorContato[contato.id_contato] || 0;
                                        colContato = (
                                            <Form.Control
                                                as="select"
                                                size="sm"
                                                value={indiceSelecionado}
                                                onChange={(e) => {
                                                    const valor = Number(e.target.value);
                                                    setTelefoneSelecionadoPorContato(prev => ({
                                                        ...prev,
                                                        [contato.id_contato]: valor
                                                    }));
                                                }}
                                            >
                                                {contato.telefones.map((tel, idx) => (
                                                    <option key={idx} value={idx}>
                                                        {celularMask(tel.telefone, true)}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        );
                                    } else {
                                        colContato = contato.telefones?.length
                                            ? celularMask(contato.telefones[0].telefone, true)
                                            : '---';
                                    }

                                    return (
                                        <tr key={contato.id_contato}>
                                            <td>
                                                <span className="contato-nome">{contato.nome}</span>
                                            </td>
                                            <td className="contato-principal">{colContato}</td>
                                            <td className="text-center">
                                                <div className="agenda-acoes">
                                                    <button
                                                        className="acao-btn acao-btn--usar"
                                                        onClick={() => handleSelecionarContatoAgenda(contato)}
                                                        title="Usar contato"
                                                        type="button"
                                                    >
                                                        Usar
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-center text-muted mt-3">Nenhum contato encontrado.</p>
                )}
            </div>
        </ModalDommus>

    </div>
}
